<template>
    <Modal title="Create New Submission" width="push-40" section="showCreateDialog" @close="removeSubmissionFile">
        <div class="card createSubmission">
            <div class="card-body">

                <v-alert
                    text
                    dense
                    color="teal"
                    icon="mdi-information"
                    border="left"
                >
                    For additional information about importing POI Locations please refer to our documentation: <a href="https://docs.intuizi.com/knowledge-base/data-import/data-import-point-of-interests/" target="_blank">Data Import: Point of Interests</a>
                </v-alert>

                <ul class="pl-0" v-if="fileErrors.length">
                    <li class="text-danger list-unstyled font-weight-bold">The uploaded file "{{ originalFileName }}" contains the following errors:</li>
                    <li class="text-danger list-unstyled" v-for="error in fileErrors">- {{ error }}</li>
                </ul>
                <v-form ref="form">
                    <div class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Name</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <v-text-field
                                v-model="name"
                                label="Submission Name"
                                :rules="[requiredName]"
                            ></v-text-field>
                        </div><!--form-group-->
                    </div>

                    <div class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Brand</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <template>
                                <v-container fluid>
                                    <v-select
                                        v-model="brands"
                                        :items="all_brands"
                                        label="Brand"
                                        :rules="[requiredBrand]"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_brands" placeholder="Search" @input="search('brands')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 my-0 pl-0">
                            <v-tooltip top color="info">
                                <template v-slot:activator="{ on }">
                                    <a @click="createNewBrand" v-on="on" class="btn btn-success ml-1 text-white">
                                        <i class="fas fa-plus-circle"></i> New Brand
                                    </a>
                                </template>
                                <span>Create New Brand</span>
                            </v-tooltip>
                        </div>
                    </div>

                    <div class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> POI Locations</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <template>
                                <v-file-input
                                    show-size
                                    v-model="file"
                                    truncate-length="30"
                                    accept=".csv"
                                    label="Upload File"
                                    :error-messages="errorMessage"
                                ></v-file-input>
                            </template>

                            <v-progress-linear
                                v-if="uploading"
                                :color="color"
                                buffer-value="0"
                                height="5"
                                stream
                                rounded
                                v-model="progress"
                            >
                            </v-progress-linear>
                            <small v-if="serverFileName">...{{ serverFileName.slice(-40) }} | Total {{ new Intl.NumberFormat().format(totalPois) }} POI Locations</small>
                        </div><!--form-group-->
                    </div>

                    <div class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Update Exising POIs</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <v-switch
                                v-model="updatingPois"
                                inset
                            ></v-switch>
                        </div>
                    </div>

                    <div class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Remove Unlisted POIs</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <v-switch
                                v-model="removingPois"
                                inset
                            ></v-switch>
                        </div>
                    </div>

                    <div class="row mt-0" v-if="removingPois || updatingPois">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Primary Key</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <template>
                                <v-container fluid>
                                    <v-select
                                        v-model="primaryKey"
                                        :items="primaryKeys"
                                        label="Primary Key"
                                        :rules="[requiredPrimaryKey]"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-1 text-left">
                            <button @click.prevent="close()" class="btn btn-danger">Cancel</button>
                        </div>
                        <div class="col-2 offset-9 text-right">
                            <button @click.prevent="submitData" :disabled="submissionDisabled" class="btn btn-success">Create</button>
                        </div>
                    </div>
                </v-form>
            </div>
        </div><!--card-->
    </Modal>
</template>

<script>
import Modal from '../../Modal'
import api from "../../../api/my-data/poi/submissions";
import mixins from "../../../mixin";
export default {
    name: "CreateNewSubmission",
    mixins: [mixins],
    components: {
        Modal
    },
    data: () => ({
        name: '',

        all_brands: [],
        all_brands_copy: [],
        brands: '',
        search_brands: '',

        file: null,
        serverFileName: null,
        originalFileName: null,
        totalPois: 0,

        updatingPois: false,
        removingPois: false,
        primaryKey: 'gps-coordinates',
        primaryKeys: [
            {
                value: 'location-id',
                text: 'Location ID'
            },
            {
                value: 'gps-coordinates',
                text: 'GPS Coordinates'
            },
            {
                value: 'store-id',
                text: 'Store ID'
            },
            {
                value: 'master-id',
                text: 'Master ID'
            },
            {
                value: 'external-id',
                text: 'External ID'
            }
        ],

        progress: 0,
        uploading: false,
        color: 'cyan',
        errorMessage: '',
        fileErrors: [],

        submissionDisabled: true,

        requiredName: v => v && v.length > 0 || 'Submission Name field is required',
        requiredBrand: v => v && v > 0 || 'Brand field is required',
        requiredPrimaryKey: v => v && v.length > 0 || 'Primary Key field is required',
    }),
    methods: {
        async fetchBrands() {
            await api.getAllBrands()
                .then(res => {
                    this.all_brands = res.data
                    this.all_brands_copy = res.data
                })
        },
        async uploadSubmissionFile(formData) {
            await api.uploadSubmissionFile(
                formData,
        {
                    headers: {'Content-Type': 'multipart/form-data'},
                    onUploadProgress: function( progressEvent ) {
                        this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
                    }.bind(this)
                })
                .then(res => {
                    this.serverFileName = res.data.filename
                    this.totalPois = res.data.total_pois

                    if (this.$store.getters.getCompanyTier.pois != null && ((this.totalPois + this.$store.getters.getCompanyTierStatus.pois) > this.$store.getters.getCompanyTier.pois)) {
                        this.$toast.open({
                            message: 'The maximum number of POIs that can be imported has been reached. Your request will be reviewed by your Account Manager.',
                            type: "info",
                            duration: 7500
                        })
                    }
                })
                .catch(e => {
                    if (e.response.data.errors) {
                        this.fileErrors = e.response.data.errors
                        this.originalFileName = e.response.data.originalName
                    }
                    this.$toast.open({
                        message: e.response.data.message,
                        type: "error",
                    })
                    this.file = null
                })
        },
        prepareForm() {
            let formData = new FormData();
            formData.append('locations', this.file);

            this.uploadSubmissionFile(formData)
        },
        createNewBrand() {
            if (this.$store.getters.getCompanyTier.brands != null && (this.$store.getters.getCompanyTierStatus.brands >= this.$store.getters.getCompanyTier.brands)) {
                this.$toast.open({
                    message: 'Your company has exceeded the maximum number of custom brands. Please contact your account manager.',
                    type: "error",
                })
            } else {
                this.$parent.showCreateBrandDialog = true
            }
        },
        async createNewSubmission() {
            await api.createNewSubmission({
                name: this.name,
                brand: this.brands,
                file: this.serverFileName,
                pois: this.totalPois,
                updating: this.updatingPois,
                removing: this.removingPois,
                key: this.primaryKey
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.$parent.showCreateDialog = false;
                if (typeof this.$parent.fetchData === 'function') {
                    this.$parent.fetchData()
                }
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.$parent.showCreateDialog = false;
            })
        },
        async removeSubmissionFile() {
            await api.removeSubmissionFile({
                filename: this.serverFileName
            })
        },
        submitData() {
            if (this.$refs.form.validate()) {
                this.createNewSubmission()
            }
        },
        close() {
            if (this.serverFileName) {
                this.removeSubmissionFile()
            }
            this.$parent.showCreateDialog = false
        },
        toggle(data) {
            this.$nextTick(() => {
                if (this.selectedAll(data)) {
                    this.$data[data] = []
                } else {
                    this.$data[data] = this.$data['all_' + data].map(a => {
                        return a.value
                    })
                }
            })
        },
        search(data) {
            if (!this.$data['search_' + data]) {
                this.$data['all_' + data] = this.$data['all_' + data + '_copy'];
            }
            this.$data['all_' + data] = this.$data['all_' + data + '_copy'].filter((item) => {
                return item.text.toLowerCase().indexOf(this.$data['search_' + data].toLowerCase()) > -1;
            })
        },
    },
    computed: {

    },
    watch: {
        file: function () {
            if (this.serverFileName) {
                this.removeSubmissionFile()
            }

            if (this.file) {
                this.fileErrors = [];
                if (this.file.size < (this.allowedFileSize * 1000000)) {
                    this.errorMessage = ''
                    this.uploading = true
                    this.progress = 1
                    this.prepareForm()
                } else {
                    this.errorMessage = 'Maximum allowed filesize is ' + this.allowedFileSize + ' MB'
                }
            } else {
                this.errorMessage = ''
                this.serverFileName = null
                this.uploading = false
                this.progress = 0
                this.submissionDisabled = true
            }
        },
        progress: function () {
            if (this.progress === 100) {
                this.color = 'success'
                this.submissionDisabled = false
            }
        },
    },
    created() {

    },
    mounted() {
        this.fetchBrands()
    },
}
</script>

<style>
.push-down-36 {
    margin-top: 36px;
}

.v-input--selection-controls {
    margin-top: 1px;
}

.v-date-picker-table {
    height: auto !important;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
}

.card {
    border: none;
}

.v-input--radio-group__input .checked label {
    background-color: #ff7516;
    border-color: #ff7516;
    color: #fff;
}

.v-input__slot .v-label {
    margin-bottom: 0;
}

.v-input--radio-group__input .v-radio .v-input--selection-controls__input {
    display: none;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 32px;
    padding: 0 12px;
}

.v-dialog__content--active {
    z-index: 99998 !important;
}

.recency-options > span {
    color: #ff7516;
    border-bottom: 1px solid white;
    transition: border-bottom .3s ease-in-out;
}

.recency-options > span:hover {
    border-bottom: 1px solid #ff7516;
    cursor: pointer;
}
</style>